export default {
  SET_GAME_STATE: 'SET_GAME_STATE',
  SET_CONFIG: 'SET_CONFIG',
  SET_LOCAL_TRANSLATIONS: 'SET_LOCAL_TRANSLATIONS',
  SET_DELIVERY_PLATFORM: 'SET_DELIVERY_PLATFORM',
  SET_SELECTED_NUMBERS: 'SET_SELECTED_NUMBERS',
  SET_QUICKPICK_NUMBERS_ITEM: 'SET_QUICKPICK_NUMBERS_ITEM',
  SET_QUICKPICK_SYSTEMS_ITEM: 'SET_QUICKPICK_SYSTEMS_ITEM',
  SET_ODDS: 'SET_ODDS',
  SET_PAYTABLE: 'SET_PAYTABLE',
  SET_SUGGESTED_SYSTEMS: 'SET_SUGGESTED_SYSTEMS',
  SET_CURRENT_BET_TYPE: 'SET_CURRENT_BET_TYPE',
  SET_IS_NO_DRAW_AUTO: 'SET_IS_NO_DRAW_AUTO',
  SET_CURRENT_SPECIAL_BET: 'SET_CURRENT_SPECIAL_BET',
  SET_IS_GAME_INFO_OPEN: 'SET_IS_GAME_INFO_OPEN',
  SET_STATISTICS: 'SET_STATISTICS',
  SET_IS_STATISTICS_LOADING: 'SET_IS_STATISTICS_LOADING',
  SET_RESULTS: 'SET_RESULTS',
  SET_IS_RESULTS_LOADING: 'SET_IS_RESULTS_LOADING',
  SET_IS_SETTINGS_OPEN: 'SET_IS_SETTINGS_OPEN',
  SET_IS_PAYIN_IN_PROCESS: 'SET_IS_PAYIN_IN_PROCESS',
  SET_IS_BETSLIP_OPEN: 'SET_IS_BETSLIP_OPEN',
  SET_IS_TICKET_HISTORY_OPEN: 'SET_IS_TICKET_HISTORY_OPEN',
  SET_IS_CANCEL_MESSAGE_OPEN: 'SET_IS_CANCEL_MESSAGE_OPEN',
  SET_CANCEL_MESSAGE: 'SET_CANCEL_MESSAGE',
  SET_USER_UUID: 'SET_USER_UUID',
  SET_LAYOUT: 'SET_LAYOUT',
  CLEAR_CANCEL_MESSAGE: 'CLEAR_CANCEL_MESSAGE',
  SET_CHECK_TICKET_TIMEOUT_ID: 'SET_CHECK_TICKET_TIMEOUT_ID',
  SET_LAST_SYSTEM_SELECTION: 'SET_LAST_SYSTEM_SELECTION',
  SET_VISUALIZATION_STATE: 'SET_VISUALIZATION_STATE',
  SET_JACKPOT_STATE: 'SET_JACKPOT_STATE',
  SET_TERMINAL_USER_DATA: 'SET_TERMINAL_USER_DATA',
  SET_TERMINAL_TICKETS_HISTORY: 'SET_TERMINAL_TICKETS_HISTORY',
  SET_TERMINAL_TICKET_DETAILS: 'SET_TERMINAL_TICKET_DETAILS',
  SET_NEXT_ROUND_DATE: 'SET_NEXT_ROUND_DATE',
  SET_HEADER_ICONS_ENABLED: 'SET_HEADER_ICONS_ENABLED',
  TOGGLE_NO_DRAW: 'TOGGLE_NO_DRAW',
  SET_NO_DRAW: 'SET_NO_DRAW',
  TOGGLE_ALL_IN: 'TOGGLE_ALL_IN',
  SET_TICKET_TO_REBET: 'SET_TICKET_TO_REBET',
  SET_ACTIVE_COMPONENT: 'SET_ACTIVE_COMPONENT',
  SET_BETTING_DISABLED: 'SET_BETTING_DISABLED',
  UPDATE_CONFIG: 'UPDATE_CONFIG',
  SET_NEXT_GEN_CONFIG: 'SET_NEXT_GEN_CONFIG',
  TOGGLE_FREE_BET_MODAL: 'TOGGLE_FREE_BET_MODAL',
  TOGGLE_FREE_BET_EXPIRED_MODAL: 'TOGGLE_FREE_BET_EXPIRED_MODAL',
  SET_VISUALIZATION_LOADED: 'SET_VISUALIZATION_LOADED',
  SET_DRAWN_BALL: 'SET_DRAWN_BALL',
  SET_DRAWN_BALLS: 'SET_DRAWN_BALLS',
  SET_NEXTGEN_STANDALONE_INTEGRATION: 'SET_NEXTGEN_STANDALONE_INTEGRATION',
};
